import React, {useState, Component} from 'react';
import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form';
import {connect } from 'react-redux';
import { validate, validators, combine } from 'validate-redux-form';
import { renderField, renderTextArea, renderCurrency, renderSwitch } from '../../../Utils/renderField';
import { Link, Redirect } from 'react-router-dom';
import {SelectField, AsyncSelectField} from '../../../Utils/renderField/renderField.js'
import { formatSelects } from '../../../Utils/renderField/renderReadField';
import { api } from '../../../../../utility/api';
import { UnidadMedida, TipoUnidades } from '../../../../../utility/constants';


let tipoproducto = [];

const getProductos = (search) => {
    return api.get("productos", { search }).
    then((data) => {
        if (data) return data.results;
        return [];
    }).catch(() => {
        return [];
    });
};

class ItemArray extends Component {
    handleProductoChange = (producto) => {
        const { change, PET } = this.props;

        // Encuentra la unidad de medida predeterminada según el producto
        const unidadPorDefecto = _.find(UnidadMedida, e => e.unidad_medida === producto.tipo_medida);

        // Asigna el valor del producto
        change(`${PET}.producto`, producto);

        // Asigna la unidad predeterminada si existe
        if (unidadPorDefecto) {
            change(`${PET}.unidad_medida`, unidadPorDefecto.value);
        }
    };

    render() {
        const { eliminar, index, PET } = this.props;

        return (
            <tr key={index} className="align-items-start">
                <td className="text-center sin-borde-top" style={{width: "5%"}}>
                    <img className="action-img" src={require('assets/img/icons/Cerrar.png')} alt="Borrar"
                        title="Borrar"
                        onClick={eliminar}
                    />
                </td>
                <td className="sin-borde-top" style={{ width: "40%" }}>
                    <Field
                        name={`${PET}.producto`}
                        component={AsyncSelectField}
                        loadOptions={getProductos}
                        type="text"
                        filterOptions={false}
                        valueKey="id"
                        labelKey="nombre"
                        className="form-control"
                        changePersonalizado={this.handleProductoChange}
                    />
                </td>
                <td className="sin-borde-top"  style={{width: "10%"}}  >
                    <Field
                        name={`${PET}.cantidad`}
                        label="Cantidad"
                        type="number"
                        component={renderField}
                        className="form-control"
                    />
                </td>
                <td className="sin-borde-top"  style={{width: "10%"}}  >
                    <Field
                        name={`${PET}.unidad_medida`}
                        label="Unidad de medida"
                        valueKey="value"
                        labelKey="label"
                        options={UnidadMedida}
                        component={SelectField}
                    />
                </td>
                <td className="text-center align-middle">
                    <div className="d-flex justify-content-center align-items-center">
                        <Field
                            name={`${PET}.reportar_produccion`}
                            label=""
                            value="default"
                            component={renderSwitch}
                        />
                    </div>
                </td>
            </tr>
        );
    }
}
class renderReceta extends Component {
    state = {
        producto: null
    }
    render(){
        const {fields, meta: {error, submitFailed }, regiones, item, name} = this.props;
        return (
            <div className=" col-sm-12 p-0">
                <div className=" col-sm-12 form-group np-r p-0">
                    <div className=" table-header-wrapper">
                        <table className="table table-striped table-highlight mb-0">
                            <thead>
                            <tr>
                                <th style={{width: "5%"}}></th>
                                <th style={{width: "40%"}}>Producto</th>
                                <th style={{width: "10%"}} >Cantidad</th>
                                <th style={{width: "15%"}} >Unidad</th>
                                <th style={{width: "12%"}} >
                                    <div>Bodega Salida</div>
                                    <div>MP / Producción</div>
                                </th>
                            </tr>
                            </thead>
                            <tbody >
                            {fields.map((PET, index) => {
                                let producto = fields.get(index);
                                return (
                                    <ItemArray
                                        index={producto.id}
                                        key={index}
                                        PET={PET}
                                        item={item}
                                        producto={producto}
                                        change={this.props.change}
                                        eliminar={() => {
                                            fields.remove(index);
                                        }}
                                        />
                                );
                            }
                            )}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex justify-content-start mt-2">
                        <button type="button" className="btn btn-primary py-0" onClick={() => fields.push({reportar_produccion: true})}>
                            AGREGAR PRODUCTO
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}




let ProductoForm = (props) => {
    const { handleSubmit, item, alerta, previousStep} = props;

    return (
        <form name="productoForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
            <h4 className="t-primary text-uppercase text-center">
                Receta
            </h4>
            <div className="form-group has-feedback  col-12">
                    <FieldArray
                        name="recetas"
                        item={item}
                        component={renderReceta}
                    />
                    </div>
            <div className="row  justify-content-sm-around justify-content-center">
                <button className="btn btn-secondary m-1 align-self-center" onClick={previousStep} >REGRESAR</button>
                <button type="submit" className="btn btn-primary m-1 align-self-center">GUARDAR</button>
            </div>

        </form>
    );
};


ProductoForm =  reduxForm({
    form: 'productoForm', // a unique identifier for this form
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true,
    validate: (data) => {
        const errors = {};
        const membersArrayErrors = [];
        if(data.recetas){
            data.recetas.forEach((member, memberIndex) => {
                const memberErrors = {};
                if (!member || !member.producto) {
                    memberErrors.producto = 'Campo Requerido';
                    membersArrayErrors[memberIndex] = memberErrors;
                }
                if (!member || !member.cantidad) {
                memberErrors.cantidad = 'Campo Requerido';
                membersArrayErrors[memberIndex] = memberErrors;
                }
                if(!member || !member.unidad_medida){
                    memberErrors.unidad_medida = 'Campo Requerido';
                    membersArrayErrors[memberIndex] = memberErrors;
                }
            });
            if (membersArrayErrors.length) {
                errors.recetas = membersArrayErrors;
            }
        }
        return errors;
    }
/*     return validate(data, {
            nombre: validators.exists()('Este campo es requerido'),
            descripcion: validators.exists()('Este campo es requerido'),
            codigo: validators.exists()('Este campo es requerido'),
            precio_venta: validators.exists()('Este campo es requerido'),
            minimo_existencias: validators.exists()('Este campo es requerido'),
            tipo_producto: validators.exists()('Este campo es requerido'),
            unidad_medida: validators.exists()('Este campo es requerido'),
            empresa: validators.exists()('Este campo es requerido'),
            unidad_recepcion: validators.exists()('Este campo es requerido'),
            conversion: validators.exists()('Este campo es requerido'),
            unidad_inventario: validators.exists()('Este campo es requerido'),
        });
    }, */
})(ProductoForm);

const selector = formValueSelector('productoForm')
ProductoForm = connect(state => {
    const alerta = selector(state, 'alerta')
    const vendible = selector(state, 'vendible')
    return {
        alerta,
        vendible
      }
    })(ProductoForm)
export default ProductoForm;

